import { render } from "./ParcelList.vue?vue&type=template&id=da54d6b4"
import script from "./ParcelList.vue?vue&type=script&lang=js"
export * from "./ParcelList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__